module.exports = __webpack_public_path__ + "static/media/cognit.38a51ec3.png";